import ModelApply from '@/views/new/home/user/index/model_apply/ModelApply'

const Home = () => import('views/new/Home')
const Index = () => import('views/new/home/index/Index')
const Survey = () => import('views/new/home/index/survey/Survey')
const Instructions = () => import('views/new/home/index/instructions/Instructions')
const TechnicalSupport = () => import('views/new/home/index/technical_support/TechnicalSupport')
const Model = () => import('views/new/home/model/index/Index')

const User = () => import('views/new/home/user/index/Index')

// 新的路由
const LatestCreate = () => import('views/new/home/model/index/latest_create/LatestCreate')
const AdvancedExperience = () => import('views/new/home/model/index/advanced_experience/AdvancedExperience')
const VisitedMost = () => import('views/new/home/model/index/visited_most/VisitedMost')
const PrivateCollect = () => import('views/new/home/model/index/private_collect/PrivateCollect')
const PrivateProduction = () => import('views/new/home/model/index/private_production/PrivateProduction')
const ModelConfig = () => import('views/new/home/model/index/model_config/ModelConfig')

const RecentEditor = () => import('views/new/home/model/index/recent_editor/RecentEditor')
// const SearchResult = () => import('views/new/home/model/index/search_result/SearchResult')
const BaseInfo = () => import('views/new/home/user/index/baseinfo/BaseInfo')
const ModifyPassword = () => import('views/new/home/user/index/modify_password/ModifyPassword')
// const AccountManage = () => import('views/new/home/user/index/account_manage/AccountManage')
const PrivateBill = () => import('views/new/home/user/index/private_bill/PrivateBill')
const ConsumptionLog = () => import('views/new/home/user/index/consumption_log/ConsumptionLog')
const PanoramaSet = () => import('views/new/home/user/index/panorama_set/PanoramaSet')
const AllAccountManage = () => import('views/new/home/user/index/all_account_manage/AllAccountManage')
const HomeManagement = () => import('views/new/home/user/index/home_management/HomeManagement')

const SmsLog = () => import('views/new/home/user/index/sms_log/SmsLog')
const MarketingTools = () => import('views/new/home/user/index/marketing_tools/MarketingTools')
const MarketingManagement = () => import('views/new/home/user/index/marketing_management/MarketingManagement')


// 访问量统计的路由
const TrafficStatistics = () => import('views/new/home/index/TrafficStatistics')
const TrafficStatisticsDataOverview = () => import('views/new/home/index/TrafficStatistics/DataOverview')
const TrafficStatisticsModelAnalysis = () => import('views/new/home/index/TrafficStatistics/ModelAnalysis')
const SingleModleInfo = () => import('views/new/home/index/TrafficStatistics/SingleModleInfo')
// 公告管理的路由
const Notice = () => import('views/new/home/notice')
const VersionManage = () => import('views/new/home/notice/VersionManage')
const NoticeManage = () => import('views/new/home/notice/NoticeManage')
const PublicFiles = () => import('views/new/home/notice/PublicFiles')
// 运营配置的路由
const Parameter = () => import('views/new/home/parameter')
const RoleControl = () => import('views/new/home/parameter/role_control/RoleControl')
const Operation = () => import('views/new/home/parameter/operation/Operation')
const CompanyControl = () => import('views/new/home/parameter/company_control/CompanyControl')
// 系统配置的路由
const System = () => import('views/new/home/system')

export default {
  // 总容器
  container: {
    path: '/home',
    name: 'Home',
    component: Home,
    meta: { title: '川云引擎｜VR云展馆平台-首页' },
    redirect: '/homeIndex'
  },
  // 菜单
  parentContainer: {
    // 首页
    HomeIndex: {
      path: '/homeIndex',
      name: 'HomeIndex',
      component: Index,
      meta: { title: '川云引擎｜VR云展馆平台-首页' },
      // 二级菜单
      childrenContainer: {
        // 概况
        Survey: {
          path: 'survey',
          name: 'survey',
          component: Survey,
          meta: { title: '川云引擎｜VR云展馆平台-首页' }
        },
        // 使用说明
        Instructions: {
          path: 'instructions',
          name: 'instructions',
          component: Instructions,
          meta: { title: '川云引擎｜VR云展馆平台-使用说明' }
        },
        // 技术支持
        TechnicalSupport: {
          path: 'technicalSupport',
          name: 'technicalSupport',
          component: TechnicalSupport,
          meta: { title: '川云引擎｜VR云展馆平台-技术支持' }
        }
      }
    },
    // 模型
    ModelIndex: {
      path: '/model',
      name: 'index',
      component: Model,
      meta: { title: '川云引擎｜VR云展馆平台-模型' },
      // 二级菜单
      childrenContainer: {
        // 最新创建
        LatestCreate: {
          path: 'latest_create',
          name: 'latestCreate',
          component: LatestCreate,
          meta: { title: '川云引擎｜VR云展馆平台-最新创建' }
        },
        AdvancedExperience: {
          path: 'advanced_experience',
          name: 'AdvancedExperience',
          component: AdvancedExperience,
          meta: { title: '川云引擎｜VR云展馆平台-进阶体验' }
        },
        
        // 访问最多
        VisitedMost: {
          path: 'visited_most',
          name: 'visitedMost',
          component: VisitedMost,
          meta: { title: '川云引擎｜VR云展馆平台-访问最多' }
        },
        // 我的收藏
        PrivateCollect: {
          path: 'private_collect',
          name: 'privateCollect',
          component: PrivateCollect,
          meta: { title: '川云引擎｜VR云展馆平台-我的收藏' }
        },
        // 最近编辑
        RecentEditor: {
          path: 'recent_editor',
          name: 'recentEditor',
          component: RecentEditor,
          meta: { title: '川云引擎｜VR云展馆平台-最近编辑' }
        },
        // 我的制作
        PrivateProduction: {
          path: 'private_production',
          name: 'privateProduction',
          component: PrivateProduction,
          meta: { title: '川云引擎｜VR云展馆平台-我的制作' }
        },
        // 我的制作
        ModelConfig: {
          path: 'model_config',
          name: 'modelConfig',
          component: ModelConfig,
          meta: { title: '川云引擎｜VR云展馆平台-模型配置' }
        },
        // // 搜索结果
        // SearchResult: {
        //   path: 'search_result',
        //   name: 'searchResult',
        //   component: SearchResult,
        //   meta: { title: '川云引擎｜VR云展馆平台-搜索结果' }
        // }
      }
    },
    // 用户
    UserIndex: {
      path: '/user',
      name: 'User',
      component: User,
      meta: { title: '川云引擎｜VR云展馆平台-用户' },
      // 二级菜单
      childrenContainer: {
        // 基本资料
        BaseInfo: {
          path: 'baseInfo',
          name: 'BaseInfo',
          component: BaseInfo,
          meta: { title: '川云引擎｜VR云展馆平台-基本信息' }
        },
        // 修改密码
        ModifyPassword: {
          path: 'modify_password',
          name: 'ModifyPassword',
          component: ModifyPassword,
          meta: { title: '川云引擎｜VR云展馆平台-修改密码' }
        },
        // // 子账号管理
        // AccountManage: {
        //   path: 'account_manage',
        //   name: 'AccountManage',
        //   component: AccountManage,
        //   meta: { title: '川云引擎｜VR云展馆平台-子账号管理' }
        // },
        // 充值记录
        PrivateBill: {
          path: 'private_bill',
          name: 'PrivateBill',
          component: PrivateBill,
          meta: { title: '川云引擎｜VR云展馆平台-充值记录' }
        },
        // 消费记录
        ConsumptionLog: {
          path: 'consumption_log',
          name: 'ConsumptionLog',
          component: ConsumptionLog,
          meta: { title: '川云引擎｜VR云展馆平台-消费记录' }
        },
        // 我的需求
        ModelApply: {
          path: 'model_apply',
          name: 'ModelApply',
          component: ModelApply,
          meta: { title: '川云引擎｜VR云展馆平台-我的需求' }
        },
        // 全景设置
        PanoramaSet: {
          path: 'panorama_set',
          name: 'PanoramaSet',
          component: PanoramaSet,
          meta: { title: '川云引擎｜VR云展馆平台-全景设置' }
        }
      }
    },
    // 公告
    NoticeIndex: {
      path: '/notice',
      name: 'Notice',
      component: Notice,
      meta: { title: '川云引擎｜VR云展馆平台-公告' },
      // 二级菜单
      childrenContainer: {
        // 版本管理
        VersionManage: {
          path: 'version_manage',
          name: 'VersionManage',
          component: VersionManage,
          meta:{ title: '川云引擎｜VR云展馆平台-版本管理' }
        },
        // 公告管理
        NoticeManage: {
          path:'notice_manage',
          name:'NoticeManage',
          component:NoticeManage,
          meta:{ title: '川云引擎｜VR云展馆平台-公告管理' }
        },
        // 公开文件
        PublicFiles: {
          path:'public_files',
          name:'PublicFiles',
          component:PublicFiles,
          meta:{ title:'川云引擎｜VR云展馆平台-公开文件' }
        }
      }
    },
    // 运营
    ParameterIndex: {
      path: '/parameter',
      name: 'Parameter',
      component: Parameter,
      meta: { title: '川云引擎｜VR云展馆平台-公告' },
      // 二级菜单
      childrenContainer: {
        // 商机管理
        Operation: {
          path: 'operation',
          name: 'Operation',
          component: Operation,
          meta: { title: '川云引擎｜VR云展馆平台-商机管理' }
        },
        // 公司管理
        CompanyControl: {
          path: 'company_control',
          name: 'CompanyControl',
          component: CompanyControl,
          meta: { title: '川云引擎｜VR云展馆平台-公司管理' }
        },
        // 短信记录
        SmsLog: {
          path: 'sms_log',
          name: 'SmsLog',
          component: SmsLog,
          meta: { title: '川云引擎｜VR云展馆平台-短信记录' }
        },
        // 营销工具
        MarketingTools: {
          path: 'marketing_tools',
          name: 'MarketingTools',
          component: MarketingTools,
          meta: { title: '川云引擎｜VR云展馆平台-营销工具' }
        },
        // 营销统计
        MarketingManagement: {
          path: 'marketing_management',
          name: 'MarketingManagement',
          component: MarketingManagement,
          meta: { title: '川云引擎｜VR云展馆平台-营销统计' }
        }
      }
    },
    // 系统
    SystemIndex: {
      path: '/system',
      name: 'System',
      component: System,
      meta: { title: '川云引擎｜VR云展馆平台-系统中心' },
      // 二级菜单
      childrenContainer: {
        // 角色管理
        RoleControl: {
          path: 'role_control',
          name: 'RoleControl',
          component: RoleControl,
          meta:{ title: '川云引擎｜VR云展馆平台-角色管理' }
        },
        // 用户管理
        AllAccountManage: {
          path: 'all_account_manage',
          name: 'AllAccountManage',
          component: AllAccountManage,
          meta: { title: '川云引擎｜VR云展馆平台-用户管理' }
        },
        HomeManagement: {
          path: 'home_management',
          name: 'HomeManagement',
          component: HomeManagement,
          meta: { title: '川云引擎｜VR云展馆平台-首页管理' }
        }
      }
    }
  },
  // 无需权限的其他路由
  notParentContainer: [
    {
      path: '/trafficstatistics/',
      name: 'TrafficStatistics',
      component: TrafficStatistics,
      redirect: 'TrafficStatisticsDataOverview',
      children: [
        {
          path: 'dataoverview',
          name: 'TrafficStatisticsDataOverview',
          component: TrafficStatisticsDataOverview,
          meta: { title: '川云引擎｜VR云展馆平台-数据概览' }
        },
        {
          path: 'modelanalysis',
          name: 'TrafficStatisticsModelAnalysis',
          component: TrafficStatisticsModelAnalysis,
          meta: { title: '川云引擎｜VR云展馆平台-模型分析' }
        },
        {
          path: 'singlemodleinfo/:title',
          name: 'SingleModleInfo',
          component: SingleModleInfo,
          meta: { title: '川云引擎｜VR云展馆平台-模型分析'}
        },
        {
          path: '',
          redirect: 'dataoverview'
        }
      ]
    }
  ]
}
